export const CREATE_LOAN_FORM_CREDITOR = 'creditor'
export const CREATE_LOAN_FORM_DEBTORS = 'debtors'
export const CREATE_LOAN_FORM_DESCRIPTION = 'description'
export const CREATE_LOAN_FORM_INTEREST = 'interest'
export const CREATE_LOAN_FORM_STARTED_ON = 'startedOn'
export const CREATE_LOAN_FORM_INTERVAL = 'interval'
export const CREATE_LOAN_FORM_AMOUNT = 'amount'


// WEBPACK FOOTER //
// ./src/constants/CreateLoanFormFieldName.tsx